import FiltersDatepicker from './FiltersDatepicker'
import FiltersForm from './FiltersForm'
import FiltersMainSection from './FiltersMainSection'
import FiltersOrder from './FiltersOrder'
import FiltersQuery from './FiltersQuery'

class Filters {
  constructor(form: HTMLFormElement) {
    new FiltersForm(form)
    new FiltersOrder(form)
    new FiltersDatepicker(form).initDatePicker()
    new FiltersMainSection(form).scrollToFilters()

    const FiltesQueryInstance = new FiltersQuery(form)
    FiltesQueryInstance.getPosts()
    FiltesQueryInstance.onInputChange(() => FiltesQueryInstance.getPosts())
  }
}

export default Filters
